import flags, {Flags} from './flags';

const getFlags = (): Flags => flags;

export default getFlags;
